// extracted by mini-css-extract-plugin
export default {"userLogo":"Header_userLogo__XXums","userName":"Header_userName__GJiJA","userNameText":"Header_userNameText__VtRBN","title":"Header_title__+eVcL"};